package one.healthium.healthKit.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import loco.GENERAL_CONTINUE
import loco.HEALTH_KIT_CONNECTION_TITLE_FORMAT
import loco.HEALTH_KIT_SYNC_DESCRIPTION
import one.healthium.loco.resolve
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppButtonDefaults
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

interface HealthKitConnectBannerContract {
    fun onSkipClicked()
}

@Composable
fun HealthKitConnectBanner(
    modifier: Modifier = Modifier,
    contract: HealthKitConnectBannerContract,
) {
    Surface(
        modifier = modifier
            .padding(horizontal = 12.dp)
            .fillMaxWidth(),
        color = AppTheme.healthKitBannerStyle.containerColorOrDefault,
        shape = AppTheme.healthKitBannerStyle.shapeOrDefault,
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = 24.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                painter = painterResource(ConnectBannerHelper.healthKitIcon),
                contentDescription = null,
                modifier = Modifier.size(40.dp),
            )
            Spacer(modifier = Modifier.height(12.dp))

            Text(
                text = stringResource(loco.Res.string.HEALTH_KIT_CONNECTION_TITLE_FORMAT, ConnectBannerHelper.healthKitName.resolve()),
                style = AppTheme.textStyles.secondary_17_500,
                color = AppTheme.healthKitBannerStyle.contentColorOrDefault,
            )

            Spacer(modifier = Modifier.height(12.dp))

            Text(
                modifier = Modifier.padding(horizontal = 24.dp),
                text = stringResource(loco.Res.string.HEALTH_KIT_SYNC_DESCRIPTION),
                style = AppTheme.textStyles.secondary_14_400,
                color = AppTheme.healthKitBannerStyle.contentColorOrDefault,
                textAlign = TextAlign.Center,
            )
            Row(
                modifier = Modifier.padding(top = 33.dp, bottom = 24.dp),
                horizontalArrangement = Arrangement.Center
            ) {
                ConnectFlowContainer(action = ConnectFlowAction.CONNECT) {
                    AppButton(
                        onClick = { it.invoke() },
                        modifier = Modifier.height(45.dp),
                        colors = AppTheme.healthKitBannerStyle.actionButtonStyle,
                        elevation = AppButtonDefaults.elevatedButtonElevationZero,
                    ) {
                        Text(stringResource(loco.Res.string.GENERAL_CONTINUE))
                    }
                }
            }
        }
    }
}
